import { Component, Input } from '@angular/core'

import { FolderExportModalComponent } from '../folder-export-modal/folder-export-modal.component'
import { FolderExportModalConfig } from '../folder-export-modal/folder-export-modal-config'
import { FolderOverviewActions } from '../store'
import { FolderOverviewService } from '../store/services'
import { FolderTrafficModalComponent } from '../folder-traffic-modal/folder-traffic-modal.component'
import { FolderTrafficModalConfig } from '../folder-traffic-modal/folder-traffic-modal-config'
import { FolderVersion } from '@app/core/model/folder-version.model'
import { LanguageService } from '@app/core/service/language.service'
import { MatDialog } from '@angular/material/dialog'
import { Store } from '@ngrx/store'

@Component({
  selector: 'folder-overview-footer',
  templateUrl: './folder-overview-footer.component.html',
  styleUrls: ['./folder-overview-footer.component.scss'],
})
export class FolderOverviewFooterComponent {
  @Input() folder: FolderVersion

  constructor(
    private store$: Store,
    private dialog: MatDialog,
    private lang: LanguageService,
    protected folderOverviewService: FolderOverviewService
  ) {}

  openExportModal() {
    const data: FolderExportModalConfig = {
      title: `Export ${this.lang.get('sow')}`,
      body: `Select which document file you want to output your ${this.lang.get('sow|l')}:`,
      folder: this.folder,
    }

    this.dialog.open(FolderExportModalComponent, { data })
  }

  openTrafficModal() {
    const data: FolderTrafficModalConfig = {
      folder: this.folder,
      trafficSystemName: this.folderOverviewService.trafficSystem?.name,
      trafficableScopes: this.folderOverviewService.trafficableScopes,
      onTraffic: (scopeIds) =>
        this.store$.dispatch(FolderOverviewActions.trafficScopes({ id: this.folder.identity.id, scopeIds })),
    }

    this.dialog.open(FolderTrafficModalComponent, { data })
  }
}
